
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// Make global available in window
if (!(window as any).global) {
  (window as any).global = window;
}

// Error handler for React rendering
const renderApp = () => {
  try {
    // Make sure we can find the root element
    const rootElement = document.getElementById("root");
    if (!rootElement) {
      console.error('Root element not found');
      return;
    }

    createRoot(rootElement).render(<App />);
  } catch (error) {
    console.error('Failed to render application:', error);
  }
};

// Ensure DOM is fully loaded before rendering
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}
